module.exports = __webpack_public_path__ + "static/media/tai-portrait.6bb01023.jpg";